// import { images } from "../../../Constants/ImageUrls";
// import AnywhereHorizontalScroll from "../../HelperComponents/AnywhereHorizontalScroll";
// import { SubtitleVideo } from "../../Product/RatingandReviews/styled";
// import ScrollWrapper from "../../ScrollWrapper/ScrollWrapper";
// import VideoThumnail from "./VideoThumbnail";
// import { LeftVideoTitle, VideoThumbnailSection } from "./styled";

import { images } from '../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import VideoThumnail from '../../ProductNew/VideoReviews/VideoThumbnail';
import { VideoThumbnailSection } from '../../ProductNew/VideoReviews/styled';
import { BabyTrustImagesSection } from '../RatingandReviews/styled';

export default function MotherVideoReviews(props) {
  let {
    aplus,
    data,
    productData,
    unique,
    allReviews,
    heading,
    isFertilityProduct,
  } = props;
  // useEffect(() => {
  //     if (data) {
  //         fireEvent({
  //             category:
  //                 clothDiaper || allReviews
  //                     ? "served_section_in_myloshop"
  //                     : "served_section_in_pdp",
  //             id: productData?.id,
  //             screen_name: getScreenName(),
  //             sku_name: productData?.name,
  //             selling_price: productData?.price,
  //             pdp_variant: aplus ? "aplus" : "aplusplus",
  //             sku_nickname: productData?.nickname,
  //             section_name: "Video Reviews",
  //         });
  //     }
  // }, []);
  return (
    <BabyTrustImagesSection isFertilityProduct={isFertilityProduct}>
      <div className="heading">{heading}</div>
      <VideoThumbnailSection
        className={allReviews ? 'allReviewsDesktop' : ''}
        allReviews={allReviews}
        aplus={aplus}
        motherTrust={true}
      >
        <AnywhereHorizontalScroll
          //   allReviews={true}
          firstElementId={`${unique}-0`}
          lastElementId={`${unique}-${data?.length - 1}`}
          leftArrow={<img src={images.arrowdownforward} alt="left_arrow" />}
          rightArrow={<img src={images.arrowdownforward} alt="right_arrow" />}
          scrolledWidth={440}
        >
          {data?.map((element, index) => {
            return (
              <VideoThumnail
                videoData={element}
                itemId={`${unique}-${index}`}
                aplus={aplus}
                key={`${unique}-${index}`}
                productData={productData}
                index={index}
                allReviews={allReviews}
                motherTrust={true}
                increaseRatio={isFertilityProduct}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </VideoThumbnailSection>
    </BabyTrustImagesSection>
  );
}
